<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="page-top-wrap">
            <div class="top wrap clear">
                <h2 class="bold  float-left">My Info</h2><br>
            </div>
        </div>
        <div class="myinfo-wrap">
            <div class="info-box clear">
                <div class="title">ID(E-mail)<span class="col-red">*</span></div>
                <div><input type="text" value="Yuliakim@carrotglobal.com" /></div>
            </div>
            <div class="info-box clear">
                <div class="title">이름<span class="col-red">*</span></div>
                <div><input type="text" value="김소연" /></div>
            </div>
            <div class="info-box clear">
                <div class="title">영문명</div>
                <div><input type="text" placeholder="영문명을 입력해 주세요." /></div>
            </div>
            <div class="info-box clear">
                <div class="title">E-mail</div>
                <div><input type="text" placeholder="E-mail을 입력해 주세요." /></div>
            </div>
            <div class="info-box clear">
                <div class="title">비밀번호</div>
                <div class="title"></div>
                <div class="title"></div>
                <div>
                    <button class="btn-base-white">변경</button>
                </div>
            </div>
        </div>
        <div class="btn clear">
            <button class="btn-base-white float-left">수정</button>
            <button class="float-right mod">변경하기</button>
        </div>
    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'ChangePw',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        pwVisible: false,
        tab: 1
    }),
    mounted() {
        //    this.doc_del_rendar();
    },
    methods: {
        changeTab(target) {
            this.tab = target;
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    padding-bottom: 10px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    .page-top-wrap {
        width: 100%;

        .top {
            // padding-right: 20px;
            padding-bottom: 17px;
            padding-top: 70px;
            // background: url("../assets/img/top-bg.png") no-repeat right -80px;
            background-size: 300px;
            position: relative;

            .my-reason {
                position: absolute;
                right: 0;
                bottom: 15%;
            }

            p {
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
            }

            div {
                select {
                    border: 1px solid var(--unnamed-color-53caff);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #53CAFF;
                    border-radius: 4px;
                    opacity: 1;
                    color: #53CAFF;
                    ;
                }
            }
        }

    }

    .myinfo-wrap {
        .info-box {
            border-bottom: 1px solid #E9E9E9;
            padding-top: 20px;
            padding-bottom: 20px;

            div {
                float: left;
            }

            .title {
                width: 100px;
                text-align: left;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                box-sizing: border-box;
                padding-left: 20px;
            }

            div {
                width: 70%;

                input[type="text"],
                input[type="password"] {
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                    width: 100%;
                    color: #000000;
                    width: 100%;
                }
            }
            &:last-child{
                border-bottom: 0px solid #000;
            }
        }
    }

    .btn {
        padding-top: 20px;
        .mod {
            background: #53CAFF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            padding: 5px 10px;
            border: none;
        }
    }
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {}
</style>
